<!-- 历史价格 -->
<div style="width: 100%; height: 100%">
    <h2 style="font-size: 32px; text-align: center; font-weight: bold;">{{title}}</h2>
    <span style="font-size: 14px; text-align: left; font-weight: bold;">{{iframeUrl}}</span>
    <ng-container>
        <iframe [src]="safeIframeUrl" width="100%" height="100%"></iframe>
    </ng-container>
</div>